export default {"src":"/_next/static/media/close-square.c352de54.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};